module.exports = __webpack_public_path__ + "525dc9d91569ab7a1a873cf595a73327.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./static/asset/logo.svg
 ** module id = 855
 ** module chunks = 0
 **/